/* eslint-disable import/prefer-default-export */
/**
 * @enum {string}
 */
export const SHIPS = {
  NONE: '-1',
  DAYS_30: '30',
  DAYS_60: '60',
  DAYS_90: '90',
  DAYS_120: '120',
};

/**
 * @type {OptionsItem[]}
 */
export const SHIP_OPTIONS = [
  {
    value: SHIPS.NONE,
    displayValue: 'Select Frequency',
  },
  {
    value: SHIPS.DAYS_30,
    displayValue: `${SHIPS.DAYS_30} Days`,
  },
  {
    value: SHIPS.DAYS_60,
    displayValue: `${SHIPS.DAYS_60} Days`,
  },
  {
    value: SHIPS.DAYS_90,
    displayValue: `${SHIPS.DAYS_90} Days`,
  },
  {
    value: SHIPS.DAYS_120,
    displayValue: `${SHIPS.DAYS_120} Days`,
  },
];
